import businessSettingNavigation from './businessSettingNavigation'
import sliderNavigation from './sliderNavigation'
import categoryNavigation from './categoryNavigation'
import childCategoryNavigation from './childCategoryNavigation'
import productNavigation from './productNavigation'
import customerNavigation from './customerNavigation'
import fbPixelNavigation from './fbPixelNavigation'
import facebookPixelNavigation from './facebookPixelNavigation'
import orderNavigation from './orderNavigation'
import orderExportNavigation from './orderExportNavigation' // ✅ ADD
import mediaNavigation from './mediaNavigation'
import roleNavigation from './roleNavigation'
import subCategoryNavigation from './subCategoryNavigation'
import userNavigation from './userNavigation'
import masterSettingNavigation from './masterSettingNavigation'
import cmsPagesNavigation from './cmsPagesNavigation'

export default [
  ...userNavigation,
  ...roleNavigation,
  ...categoryNavigation,
  ...subCategoryNavigation,
  ...childCategoryNavigation,
  ...productNavigation,
  ...mediaNavigation,
  ...sliderNavigation,
  ...customerNavigation,
  ...orderNavigation,
  ...orderExportNavigation, // ✅ ADD HERE

  ...fbPixelNavigation,
  ...facebookPixelNavigation,

  ...masterSettingNavigation,
  ...businessSettingNavigation,
  ...cmsPagesNavigation,
]